<mat-dialog-content class="content">
  @if (showCloseIcon) {
    <div type="button" class="close-icon" aria-label="Close dialog" (click)="closeDialog()">
      x
    </div>
  }
  <p class="dialog-title">Set a Career Goal </p>
  <p class="description">
    When you’ve found a career that feels right for you, 
    click Set as Career Goal on the career page. This will help personalize 
    your recommendations - from skills to build to job opportunities to explore - 
    and you can always change it later.
  </p>
  <img 
    src='/assets/images/results/career-goal-modal.png' 
    alt="career-goal"
    class="career-goal-image"
  />
</mat-dialog-content>
<mat-dialog-actions>
  <div class="actions-div">
    <button
      mat-flat-button
      mat-dialog-close
      type="button"
      class="continue-btn"
      (click)="onClickContinue()"
    >
    Continue
    </button>
  </div>
</mat-dialog-actions>
